/**
 * 创建人：但志强
 * 时间：2019-03-19
 * 描述：表格工具栏组件
 * 使用说明: 参考 sw-toolbar 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, Output, EventEmitter, ContentChild, TemplateRef, HostListener, ElementRef, ViewChild } from '@angular/core';
import { PlatformLocation } from '@angular/common'
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { Router } from '@angular/router';
declare var $: any;

/**
 * 表格工具栏组件  sw-toolbar
 */
@Component({
  selector: 'sw-toolbar',
  templateUrl: './sw-toolbar.component.html',
  styleUrls: ['./sw-toolbar.component.css']
})

export class SwToolbarComponent implements OnInit {

  /**
   * 工具栏数据
   * @ignore
   */
  @Input() toolbar: any = [];  
  @Input() full:boolean = false; 

  

  /**
   * 通过uri 获取按钮
   */
  @Input() urlToolBar:string="";
  /**
   * 按钮点击事件 返回 functionCode （点击按钮返回code 如： add）
   */
  @Output() operation = new EventEmitter(); 
   /**
   * 按钮点击事件  返回 target （按钮打开方式）
   */
  @Output() openType = new EventEmitter(); 

  /**
   * 按钮点击事件
   */
  @Output() clickDisplay = new EventEmitter(); 

  /**
   * 开启九宫格模式
   */
  @Input() isThumbnail:boolean = false; 
    /**
   * 表格列表是否显示筛选功能
   * @ignore
   */
  @Input() isFilter: Boolean = false
   /**
   * 表格列表筛选checkbox判断
   * @ignore
   */
  @Input() filterDatas: any = {}
   /**
   * 表格列表筛选dropdown数据
   * @ignore
   */
  @Input() filterDatasArray: any = []

  /**
   * 抛出筛选后数据
   */
  @Output() filter = new EventEmitter();

  /** 
   * 抛出toolBar的值（用于自定义表单判断新增修改查看打开方式）
  */
 @Output() toolbarData = new EventEmitter();

  /**
   * 是否显示列表 (当显示表格时，筛选按钮显示， 当显示九宫格时 筛选按钮隐藏)
   * @ignore
   */
  @Input() isDisplay: Boolean = true

  /**
   * 是否有全局搜索功能
   * @ignore
   */
  @Input() isGlobalSearch: Boolean = false
  

  /** 
   * 抛出全局搜索的文本
  */
  @Output() globalSearch = new EventEmitter();

   /**
   * 是否显示按钮工具栏sw-toolbar中 表格和九宫格切换的按钮 默认显示
   */
  @Input() isDisplayThumbBtn: boolean = true;
  /**
   * 子按钮下拉的最大高度
   */
  @Input() dropMaxHeight: string = '140px';
  
   /** 
   * 是否需要将业务查询表格数据的查询条件放在按钮工具栏內  是否选择样式1
  */
 @Input() isAdvancedSearch: boolean = false
  /**
   * 查询条件放在按钮栏內 且选择的样式为1的查询数据
   * @ignore
   */
  @ContentChild('advancedSearch') advancedSearchTmpl: TemplateRef<any>;

  /** 
   * 按钮工具栏是否可在左侧自定义输入内容
  */
 @Input() isLeftCustom: boolean = false
 /**
  * 按钮工具栏是在左侧自定义输入内容
  * @ignore
  */
 @ContentChild('leftCustom') leftCustomTmpl: TemplateRef<any>;

 /** 
   * 按钮工具栏是否可在右侧自定义输入内容
  */
 @Input() isRightCustom: boolean = false
 /**
  * 按钮工具栏是在左侧自定义输入内容
  * @ignore
  */
 @ContentChild('rightCustom') rightCustomTmpl: TemplateRef<any>;
    /**
   * 表格数据是否排序 （非表头排序） toolbar下拉排序 功能
   */
  @Input() isOrder: boolean = false

  /**
   * orderNames 下拉排序对应字段值（和表格表头排序对应的columnname相同） 数组
   * {id:"",text:""} 
   */
  @Input() orderNames: any = [];  

   /**
   * defaultOrderBy 下拉排序对应的默认选中值 字符串 格式类型为 't.' + orderName + ' ' + orderType
   * 业务端传入
   * t.role_name asc
   */
  @Input() defaultOrderBy:string = ""
   /**
   * 选中排序数据
   */
  @Output() order =  new EventEmitter();

  /**
   * 是否有统计按钮
   */
  @Input() isStatistic: boolean = false
  /**
   * 按钮栏最小高度
   */
  @Input() minHeight: string = '40px'
  /**
   *系统配置按钮是否显示右边
   */
  @Input() isDefaultRight: boolean = false
  /** 
   * 全局搜索表单双向绑定的数据
   * @ignore
  */
  globalSearchText:string
 
   /**
   * 隐藏时的定位
   * @ignore 
   */
 
  isEnUs:boolean = false; //当前语言是否为英文English 是英文为true  不是英文（是中文）为false
  /**
   * @ignore
   * @param location  获取当前uri
   * @param jwt  获取数据缓存
   * @param http  http请求
   */
  constructor( 
    private location: PlatformLocation,
    private jwt:SwJwtService,
    private http: SwHttpClientService,
    private systemId: SystemIdService,
    private router: Router,
    private _elementRef: ElementRef
    ) {
      //获取当前语言
      let currLanguage = this.jwt.getToken('language')
      if(currLanguage == 'en-US'){
      this.isEnUs = true
      }else {
        this.isEnUs = false
      }
    }

  /**
   * @ignore
   */
  ngOnInit() {
    // 优先使用传入的按钮数组，没有的话，就去根据路径查配置的按钮
    if (this.toolbar && this.toolbar.length == 0)
      this.toolbarInit(this.urlToolBar);
  }

  /**
   * @ignore
   */
  ngOnChanges(): void {
  }
  /**
   * @ignore
   * @param br 是否开启九宫格模式
   */
  onClickDisplay(br){
    // 抛出
    this.isDisplay = br
    this.clickDisplay.emit(br);
  }
  /**
   * 初始化按钮
   * @param urlToolBar 请求路由
   */
  toolbarInit(urlToolBar:string) {
    // 根据路径去查询配置的按钮
    let pathname=["/","",""]
    try{
      pathname = this.location["location"].hash.split('?')[0].split("/");
    }catch(e){
      
    }
    let systemId = this.jwt.getToken("systemId")
    // 准备拼接url
    let url = environment.seekerWebAPI+"function/queryButtonsByUri"
    // 要去掉#，故第一个参数不使用

  
    if(urlToolBar == ""){ 
      if(pathname.length>1){
        // 拼接uri
        url = url+"?uri=";
        for (let index = 1; index < pathname.length; index++) {
          const element = pathname[index];
          url = url+"/"+pathname[index]
        }
      }
    }else{
      url = url+"?uri="+urlToolBar;
    }
    // 拼接系统ID参数
    url = url+"&systemId=" + systemId;
    this.http.Post(url, {}).subscribe(data => {
      this.toolbar = data["data"];
      this.toolbarData.emit(this.toolbar)
    });
   

  }

  /**
   * 启用全部按钮
   */
  toolbarAllEnable() {
    for (let tool of this.toolbar) {
      tool["status"] = true;
      if(tool.children.length>0) {
         for(let tol of tool.children) {
            tol["status"] = true;
         }
      }
    }
     
  }
  /**
   * 启用单个按钮
   * @param key  按钮的code
   */
  toolbarEnable(key: string) {
    for (let tool of this.toolbar) {
      if (tool.functionCode == key) {
        tool["status"] = true;
      }
      if(tool.children.length>0) {
        for(let tol of tool.children) {
          if (tol.functionCode == key) {
            tol["status"] = true;
          }
        }
     } 
    } 
  }
  /**
   * 禁用全部按钮
   */
  toolbarAllDisable() {
    for (let tool of this.toolbar) {
      tool["status"] = false;
      if(tool.children.length>0) {
         for(let tol of tool.children) {
            tol["status"] = false;
         }
      }
    }
  }
  /**
   * 禁用单个按钮
   * @param key  按钮的code
   */
  toolbarDisable(key: string) {
    for (let tool of this.toolbar) {
      if (tool.functionCode == key) {
        tool["status"] = false;
      }
      if(tool.children.length>0) {
        for(let tol of tool.children) {
          if (tol.functionCode == key) {
            tol["status"] = false;
          }
        }
      } 
    }
  }
  /**
   * 展示全部按钮
   */
  toolbarAllShow() {
    for (let tool of this.toolbar) {
      tool["isHidden"] = false;
      if(tool.children.length>0) {
         for(let tol of tool.children) {
            tol["isHidden"] = false;
         }
      }
    }
  }
  /**
   * 展示单个按钮
   * @param key  按钮的code
   */
  toolbarShow(key: string) {
    for (let tool of this.toolbar) {
      if (tool.functionCode == key) {
        tool["isHidden"] = false;
      }
      if(tool.children.length>0) {
        for(let tol of tool.children) {
          if (tol.functionCode == key) {
            tol["isHidden"] = false;
          }
        }
     } 
    } 
  }
  /**
   * 隐藏全部按钮
   */
  toolbarAllHide() {
    for (let tool of this.toolbar) {
      tool["isHidden"] = true;
      if(tool.children.length>0) {
         for(let tol of tool.children) {
            tol["isHidden"] = true;
         }
      }
    }
  }
   /**
   * 隐藏单个按钮
   * @param key  按钮的code
   */
  toolbarHide(key: string) {
    for (let tool of this.toolbar) {
      if (tool.functionCode == key) {
        tool["isHidden"] = true;
      }
      if(tool.children.length>0) {
        for(let tol of tool.children) {
          if (tol.functionCode == key) {
            tol["isHidden"] = true;
          }
        }
      } 
    }
  }

  /**
   * 禁用按钮
   * @param type 如果输入all 则禁用全部  
   */
  disableToolbar(type: string) {
    if (type !== "all")
      this.toolbarDisable(type);
    else
      this.toolbarAllDisable();
  }
  /**
   * 启用按钮
   * @param type  如果输入all 则启用全部
   */
  enableToobar(type: string) {
    if (type !== "all")
      this.toolbarEnable(type);
    else
      this.toolbarAllEnable();
  }

  /**
   * 隐藏按钮
   * @param type 如果输入all 则隐藏全部 
   */
  hideToolbar(type: string) {
    if (type !== "all")
      this.toolbarHide(type);
    else
      this.toolbarAllHide();
  }
  /**
   * 显示按钮
   * @param type  如果输入all 则显示全部
   */
  showToobar(type: string) {
    if (type !== "all")
      this.toolbarShow(type);
    else
      this.toolbarAllShow();
  }
  /**
   * 点击按钮触发事件
   * @param event 当前对象 
   * @param type 选中的按钮code
   */
  onOperation(event: Event, type: string){
    event.stopPropagation();
    this.operation.emit(type);
    //return false
  }

  /**
   * 点击全局搜索按钮
   */
  clickGlobalSearch(){
    this.globalSearch.emit(this.globalSearchText)
  }
  /**
   * 按钮连接路径（打开方式为tab类型）
   */
  toNavigate(tol) {
    if(tol.target == 'SYS0602' && tol.uri){
      let route = tol.uri
      let url = route.split('?')[0]; //获取跳转路径
      let param = route.split('?')[1]; //获取参数
      if(param){
        let params = this.getUrlVars(param)
        let queryParams = {
         queryParams:params
        }
        this.router.navigate([url], queryParams);
      }else {
        this.router.navigate([url]);
      }
    }
  }
    /**
   * 处理url参数，转为json对象
   * 如 'Title=内容查看&Operate=view&languageType=CN&groupId=dfb28e30a08b4cd39a7ee57b5993c5c2'
   * @ignore
   */
  getUrlVars(url) { 
    var hash;
    var myJson = {};
    var hashes = url.slice(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        myJson[hash[0]] = hash[1];
    }
    return myJson;
  }
 
  //监听查询2事件 以外隐藏
  // @HostListener('document:click', ['$event.target'])
  // public onClick(targetElement) {
  //   if(this.show){
  //     const clickInside = this.searchDropdown.nativeElement.contains(targetElement); //是否在筛选查询盒子內
  //     const clickInsideWrapper = document.getElementsByClassName('wrapper')[0].contains(targetElement); //是否在wrapper盒子內
  //     if(clickInsideWrapper && !clickInside) {
  //       this.clickToClose()
  //     }
  //   }
  // }
}
